module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/FeaturedList-aba166c65d3f642521858da0fc0d06c3.png";